import {Fragment, h} from 'preact';
import Button from '../form/Button';
import Dialog from '../media/Dialog';
import {useCallback, useState} from 'preact/hooks';
import {Job} from '../../model/Job';
import JobSection from '../../model/JobSection';
import JobSectionItem from '../../model/JobSectionItem';
import DeleteSectionItemsForm from './DeleteSectionItemsForm';
import {IconType} from '../media/Icon';

interface Props {
  job: Job;
  section: JobSection;
  items: JobSectionItem[];
  onSuccess?(): any;
}

export default function DeleteSectionItemsButton({job, section, items, onSuccess}: Props) {
  const {length} = items;
  if (length === 0)
    return null;

  const [showDialog, toggleDialog] = useState(false);

  const dialog = {
    show: toggleDialog.bind(null, true),
    hide: toggleDialog.bind(null, false)
  };

  const click = useCallback((event: MouseEvent) => {
    event.stopPropagation();
    if (!showDialog) toggleDialog(true);
  }, [toggleDialog, showDialog, job, section, items]);

  return (
    <Fragment>
      <Button
        small={true}
        danger={true}
        onClick={click}
        onlyIcon={IconType.DELETE_ITEM}
        tooltip={`Delete${length > 1 ? ` ${length}`:''} Item${length === 1 ? '':'s'}`}
      />
      <Dialog show={showDialog} onRequestClose={dialog.hide}>
        <DeleteSectionItemsForm
          job={job}
          section={section}
          items={items}
          onCancel={dialog.hide}
          onSuccess={() => {
            if (onSuccess) onSuccess();
            dialog.hide();
          }}
        />
      </Dialog>
    </Fragment>
  )
}